@if (showAny()) {
  <div class="feedback-hints">
    @if (showSettings().favourite) {
      <div class="has-span" [class.red]="is_liked">
        <app-svg src="/assets/icons/heart-filled.svg"></app-svg>
        <span>{{ likes }}</span>
      </div>
    }
    @if (showSettings().status) {
      <div class="{{ status | assetStatusColor }}">
        <app-svg [src]="'/assets/icons/' + (status | assetStatusIcon) + '.svg'"></app-svg>
      </div>
    }
    @if (showSettings().color_label) {
      <div class="{{ color_label }}">
        <app-svg src="/assets/icons/color-label-filled.svg"></app-svg>
      </div>
    }
    @if (showSettings().comment) {
      <div class="has-span">
        <app-svg src="/assets/icons/comment-bubble.svg"></app-svg>
        <span>{{ commentThreadCount }}</span>
      </div>
    }
  </div>
}
